// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPhoneNumberForm-errorMessage-Ze9ZU {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.AddPhoneNumberForm-space1-RgXQ3 {
	margin-bottom: 6px !important;
}
.AddPhoneNumberForm-space2-t437W {
	margin-bottom: 12px !important;
}
.AddPhoneNumberForm-space3-KdmZ9 {
	margin-bottom: 18px !important;
}
.AddPhoneNumberForm-space4-C8lQe {
	margin-bottom: 24px !important;
}
.AddPhoneNumberForm-space5-IM6fG {
	margin-bottom: 30px !important;
}
.AddPhoneNumberForm-space6-B64Bw {
	margin-bottom: 36px !important;
}
.AddPhoneNumberForm-space7-sV00e {
	margin-bottom: 42px !important;
}
.AddPhoneNumberForm-spaceTop8-HvrSp {
	margin-bottom: 48px !important;
}
.AddPhoneNumberForm-spaceTop1-H984o {
	margin-top: 6px !important;
}
.AddPhoneNumberForm-spaceTop2-cFOK5 {
	margin-top: 12px !important;
}
.AddPhoneNumberForm-spaceTop3-ebqYZ {
	margin-top: 18px !important;
}
.AddPhoneNumberForm-spaceTop4-btuvb {
	margin-top: 24px !important;
}
.AddPhoneNumberForm-spaceTop5-X4aYv {
	margin-top: 30px !important;
}
.AddPhoneNumberForm-spaceTop6-JSXVl {
	margin-top: 36px !important;
}
.AddPhoneNumberForm-spaceTop7-o5Gms {
	margin-top: 42px !important;
}
.AddPhoneNumberForm-spaceTop8-HvrSp {
	margin-top: 48px !important;
}
.AddPhoneNumberForm-noMargin-_5BNM {
	margin: 0px !important;
}
.AddPhoneNumberForm-padding1-wzEwS {
	padding-bottom: 6px !important;
}
.AddPhoneNumberForm-padding2-LIFMA {
	padding-bottom: 12px !important;
}
.AddPhoneNumberForm-padding3-dD1P2 {
	padding-bottom: 18px !important;
}
.AddPhoneNumberForm-padding4-B2ac7 {
	padding-bottom: 24px !important;
}
.AddPhoneNumberForm-padding5-bdapG {
	padding-bottom: 30px !important;
}
.AddPhoneNumberForm-padding6-gWj8t {
	padding-bottom: 36px !important;
}
.AddPhoneNumberForm-padding7-cKzi5 {
	padding-bottom: 42px !important;
}
.AddPhoneNumberForm-paddingTop1-HhODP {
	padding-top: 6px !important;
}
.AddPhoneNumberForm-paddingTop2-VfqAZ {
	padding-top: 12px !important;
}
.AddPhoneNumberForm-paddingTop3-e5s1S {
	padding-top: 18px !important;
}
.AddPhoneNumberForm-paddingTop4-JuoX0 {
	padding-top: 24px !important;
}
.AddPhoneNumberForm-paddingTop5-_V424 {
	padding-top: 30px !important;
}
.AddPhoneNumberForm-paddingTop6-Dv_lw {
	padding-top: 36px !important;
}
.AddPhoneNumberForm-paddingTop7-z4g85 {
	padding-top: 42px !important;
}
.AddPhoneNumberForm-noPadding-WwaLx {
	padding: 0px !important;
}
.AddPhoneNumberForm-textBold-gVEcf {
	font-weight: 500 !important;
}
.AddPhoneNumberForm-textBolder-Eskru {
	font-weight: 700 !important;
}
.AddPhoneNumberForm-textNormal-DnMT8 {
	font-weight: normal !important;
}
.AddPhoneNumberForm-spaceBottom20-IbUZJ {
	margin-bottom: 20px;
}
.AddPhoneNumberForm-spaceBottom10-QK9LD {
	margin-bottom: 10px;
}
.AddPhoneNumberForm-marginNone-zZDcB {
	margin: 0;
}
.AddPhoneNumberForm-spaceBottom15-Etnmz {
	margin-bottom: 15px;
}
.AddPhoneNumberForm-marginTopNone-u7aCv {
	margin-top: 0;
}
.AddPhoneNumberForm-spaceTop11-PzIJe {
	margin-top: 11px;
}
.AddPhoneNumberForm-spaceTop21-Yknk6 {
	margin-top: 21px;
}
.AddPhoneNumberForm-spaceTop20-m288i {
	margin-top: 20px;
}
.AddPhoneNumberForm-spaceTop10-kk32a {
	margin-top: 10px;
}
/*New Design Text Colors */
.AddPhoneNumberForm-textDarkBlue-Zji3b {
	color: rgb(20, 39, 94) !important;
}
.AddPhoneNumberForm-textLightBlue-nI6NF {
	color: rgb(57, 87, 106) !important;
}
.AddPhoneNumberForm-textLightSandleGreen-ATWIM {
	color: rgb(76, 86, 41) !important;
}
.AddPhoneNumberForm-textLightBrown-ORhAn {
	color: rgb(115, 79, 33) !important;
}
.AddPhoneNumberForm-textMediumMaroon-cUIAs {
	color: rgb(87, 37, 51) !important;
}
.AddPhoneNumberForm-textBrown-XOLDl {
	color: rgb(160, 47, 24) !important;
}
.AddPhoneNumberForm-textMaroon-QxbtG {
	color: rgb(155, 49, 67) !important;
}
.AddPhoneNumberForm-textDarkBrown-s9dIf {
	color: rgb(83, 18, 16) !important;
}
.AddPhoneNumberForm-textMediumBrown-lP0vN {
	color: rgb(142, 28, 10) !important;
}
.AddPhoneNumberForm-textSkyBlue-YT3LJ {
	color: rgb(37, 117, 141) !important;
}
.AddPhoneNumberForm-textGray-G3Nbb {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.AddPhoneNumberForm-formGroup-VtO4B {
	margin-bottom: 15px !important;
}
.AddPhoneNumberForm-select-erdqr {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}
.AddPhoneNumberForm-labelText-D1yyR {
	font-size: 15px;
	color: var(--primary-foreground);
	margin: 6px 0px;
	line-height: 1.43;
	font-weight: normal;
}
.AddPhoneNumberForm-formContainer-XpALU {
	border: 1px solid var(--primary-border);
	padding: 15px;
	border-radius: 2px;
}
.AddPhoneNumberForm-phoneNumberCheckBox-vQVvt {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	gap: 8px;

}
.AddPhoneNumberForm-indicationTxt-S0los {
	font-size: 14px;
	line-height: normal;
	margin: 0;
}
.AddPhoneNumberForm-indicationTxt-S0los a,
.AddPhoneNumberForm-indicationTxt-S0los a:hover,
.AddPhoneNumberForm-indicationTxt-S0los a:focus {
	color: var(--primary-link-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/PhoneVerificationModal/AddPhoneNumberForm/AddPhoneNumberForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,sBAAsB;AACtB;CACC,8BAA8B;AAC/B;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,uCAAuC;CACvC,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,QAAQ;;AAET;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,SAAS;AACV;AAEA;;;CAGC,qCAAqC;AACtC","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../../helpers.css';\n\n/** RentAll - Begin **/\n.formGroup {\n\tmargin-bottom: 15px !important;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.labelText {\n\tfont-size: 15px;\n\tcolor: var(--primary-foreground);\n\tmargin: 6px 0px;\n\tline-height: 1.43;\n\tfont-weight: normal;\n}\n\n.formContainer {\n\tborder: 1px solid var(--primary-border);\n\tpadding: 15px;\n\tborder-radius: 2px;\n}\n\n.phoneNumberCheckBox {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 8px;\n\n}\n\n.indicationTxt {\n\tfont-size: 14px;\n\tline-height: normal;\n\tmargin: 0;\n}\n\n.indicationTxt a,\n.indicationTxt a:hover,\n.indicationTxt a:focus {\n\tcolor: var(--primary-link-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AddPhoneNumberForm-errorMessage-Ze9ZU`,
	"space1": `AddPhoneNumberForm-space1-RgXQ3`,
	"space2": `AddPhoneNumberForm-space2-t437W`,
	"space3": `AddPhoneNumberForm-space3-KdmZ9`,
	"space4": `AddPhoneNumberForm-space4-C8lQe`,
	"space5": `AddPhoneNumberForm-space5-IM6fG`,
	"space6": `AddPhoneNumberForm-space6-B64Bw`,
	"space7": `AddPhoneNumberForm-space7-sV00e`,
	"spaceTop8": `AddPhoneNumberForm-spaceTop8-HvrSp`,
	"spaceTop1": `AddPhoneNumberForm-spaceTop1-H984o`,
	"spaceTop2": `AddPhoneNumberForm-spaceTop2-cFOK5`,
	"spaceTop3": `AddPhoneNumberForm-spaceTop3-ebqYZ`,
	"spaceTop4": `AddPhoneNumberForm-spaceTop4-btuvb`,
	"spaceTop5": `AddPhoneNumberForm-spaceTop5-X4aYv`,
	"spaceTop6": `AddPhoneNumberForm-spaceTop6-JSXVl`,
	"spaceTop7": `AddPhoneNumberForm-spaceTop7-o5Gms`,
	"noMargin": `AddPhoneNumberForm-noMargin-_5BNM`,
	"padding1": `AddPhoneNumberForm-padding1-wzEwS`,
	"padding2": `AddPhoneNumberForm-padding2-LIFMA`,
	"padding3": `AddPhoneNumberForm-padding3-dD1P2`,
	"padding4": `AddPhoneNumberForm-padding4-B2ac7`,
	"padding5": `AddPhoneNumberForm-padding5-bdapG`,
	"padding6": `AddPhoneNumberForm-padding6-gWj8t`,
	"padding7": `AddPhoneNumberForm-padding7-cKzi5`,
	"paddingTop1": `AddPhoneNumberForm-paddingTop1-HhODP`,
	"paddingTop2": `AddPhoneNumberForm-paddingTop2-VfqAZ`,
	"paddingTop3": `AddPhoneNumberForm-paddingTop3-e5s1S`,
	"paddingTop4": `AddPhoneNumberForm-paddingTop4-JuoX0`,
	"paddingTop5": `AddPhoneNumberForm-paddingTop5-_V424`,
	"paddingTop6": `AddPhoneNumberForm-paddingTop6-Dv_lw`,
	"paddingTop7": `AddPhoneNumberForm-paddingTop7-z4g85`,
	"noPadding": `AddPhoneNumberForm-noPadding-WwaLx`,
	"textBold": `AddPhoneNumberForm-textBold-gVEcf`,
	"textBolder": `AddPhoneNumberForm-textBolder-Eskru`,
	"textNormal": `AddPhoneNumberForm-textNormal-DnMT8`,
	"spaceBottom20": `AddPhoneNumberForm-spaceBottom20-IbUZJ`,
	"spaceBottom10": `AddPhoneNumberForm-spaceBottom10-QK9LD`,
	"marginNone": `AddPhoneNumberForm-marginNone-zZDcB`,
	"spaceBottom15": `AddPhoneNumberForm-spaceBottom15-Etnmz`,
	"marginTopNone": `AddPhoneNumberForm-marginTopNone-u7aCv`,
	"spaceTop11": `AddPhoneNumberForm-spaceTop11-PzIJe`,
	"spaceTop21": `AddPhoneNumberForm-spaceTop21-Yknk6`,
	"spaceTop20": `AddPhoneNumberForm-spaceTop20-m288i`,
	"spaceTop10": `AddPhoneNumberForm-spaceTop10-kk32a`,
	"textDarkBlue": `AddPhoneNumberForm-textDarkBlue-Zji3b`,
	"textLightBlue": `AddPhoneNumberForm-textLightBlue-nI6NF`,
	"textLightSandleGreen": `AddPhoneNumberForm-textLightSandleGreen-ATWIM`,
	"textLightBrown": `AddPhoneNumberForm-textLightBrown-ORhAn`,
	"textMediumMaroon": `AddPhoneNumberForm-textMediumMaroon-cUIAs`,
	"textBrown": `AddPhoneNumberForm-textBrown-XOLDl`,
	"textMaroon": `AddPhoneNumberForm-textMaroon-QxbtG`,
	"textDarkBrown": `AddPhoneNumberForm-textDarkBrown-s9dIf`,
	"textMediumBrown": `AddPhoneNumberForm-textMediumBrown-lP0vN`,
	"textSkyBlue": `AddPhoneNumberForm-textSkyBlue-YT3LJ`,
	"textGray": `AddPhoneNumberForm-textGray-G3Nbb`,
	"formGroup": `AddPhoneNumberForm-formGroup-VtO4B`,
	"select": `AddPhoneNumberForm-select-erdqr`,
	"labelText": `AddPhoneNumberForm-labelText-D1yyR`,
	"formContainer": `AddPhoneNumberForm-formContainer-XpALU`,
	"phoneNumberCheckBox": `AddPhoneNumberForm-phoneNumberCheckBox-vQVvt`,
	"indicationTxt": `AddPhoneNumberForm-indicationTxt-S0los`
};
module.exports = ___CSS_LOADER_EXPORT___;
